<ng-container *ngIf="remoteConfigStore.showGenericInfoBanner$ | async">
  <app-banner
    [title]="'+INSTALLATIONS.NOTIFICATIONS.GENERIC_INFO_BANNER.TITLE' | translate"
    [type]="BannerType.info"
  >
    {{ '+INSTALLATIONS.NOTIFICATIONS.GENERIC_INFO_BANNER.DESCRIPTION' | translate }}
  </app-banner>
</ng-container>
